import Ctl from '@/orm/models/Ctl'
import apiRequest from '@/network/httpClient'
import { Defaults, Options } from '@/orm/models/Setting'
import CtlClassesRepo from '@/orm/repositories/CtlClassesRepo'
import CtlNominationsRepo from '@/orm/repositories/CtlNominationsRepo'
import SettingsRepo from '@/orm/repositories/SettingsRepo'
import VenuesRepo from '@/orm/repositories/VenuesRepo'
import { AxiosRepository } from '@pinia-orm/axios'
import { useRepo } from 'pinia-orm'

export default class CtlRepo extends AxiosRepository<Ctl> {
    use = Ctl

    hasEvents() {
        return this.all().length > 0
    }

    eventsList() {
        return this.all()
            .map((event) => ({
                label: event.id + ' ' + event.name,
                value: event.id,
                venue: event.venueId,
                from: new Date(event.from),
                to: event.to == null ? null : new Date(event.to),
            }))
            .sort((a, b) => a.label.localeCompare(b.label))
    }

    transformApiData(data: any[]) {
        return data.map((line) => {
            const eventId = parseInt(line.id)
            const from = new Date(line.from)
            const to = Object.hasOwn(line, 'to') ? new Date(line.to) : undefined
            const venue = Object.hasOwn(line, 'venue') ? String(line.venue) : null
            const venueId = (venue != null && venue.length > 0) ? useRepo(VenuesRepo).venueIdByName(venue) : undefined
            let eventTo = null

            if (typeof to === 'undefined' && Object.hasOwn(line, 'days')) {
                eventTo = new Date(line.from)
                eventTo.setDate(from.getDate() + parseInt(line.days))
            }

            return {
                cancelled: Object.hasOwn(line, 'isCancelled') ? Boolean(line.isCancelled) : false,
                clubId: Object.hasOwn(line, 'clubId') ? parseInt(line.clubId) : undefined,
                days: Object.hasOwn(line, 'days')
                    ? parseInt(line.days)
                    : (typeof to !== 'undefined'
                        ? Math.floor((to.valueOf() - from.valueOf()) / (1000 * 60 * 60 * 24))
                        : undefined),
                description: Object.hasOwn(line, 'description') ? String(line.description) : undefined,
                from: from,
                id: eventId,
                name: String(line.name),
                noticeboardUrl: Object.hasOwn(line, 'noticeboardUrl') ? String(line.noticeboardUrl) : undefined,
                organizer: Object.hasOwn(line, 'organizer') ? String(line.organizer) : undefined,
                otherVenue: venueId == null ? venue : undefined,
                registrationUrl: Object.hasOwn(line, 'registrationUrl') ? String(line.registrationUrl) : undefined,
                to: typeof to === 'undefined' ? eventTo : to,
                venueId: venueId != null ? venueId : undefined,
                courses: Object.hasOwn(line, 'courses') ? parseInt(line.courses) : 1,
            }
        })
    }

    async update() {
        const authToken = useRepo(SettingsRepo).getOption(Options.AuthToken, Defaults.AuthToken)

        useRepo(CtlClassesRepo).flush()
        useRepo(CtlNominationsRepo).flush()
        this.flush()

        const response = await apiRequest(authToken).get('/events/list')

        const data = response.data

        this.save(this.transformApiData(data))
        useRepo(CtlClassesRepo).saveFromApiData(data)
        useRepo(CtlNominationsRepo).saveFromApiData(data)

        return response
    }
}
